// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MT-I","tabsBox":"styles_tabsBox__1qXBV","createButton":"styles_createButton__1NwzG"};